<div id="chatbot-container">
  <iframe id="chatbot-iframe" src="/chatbot"></iframe>
</div>
